// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "url('https://cdn.websky.aero/content/frontend/images/nordwind-banner-preselected-service-seats.svg')";
var _4 = "wrapper-SasGt";
var _5 = "button-1m_Ay";
var _6 = "button_cancel-8GTC4";
var _7 = "seats__header-1s5Vj";
var _8 = "price-lnOhe";
var _9 = "seats__table-2GmEx";
var _a = "meal__price-37UzJ";
var _b = "wrapper_mobileFullScreen-2-7DP";
var _c = "seats__header_mobileFullScreen-ViYku";
export { _1 as "__esModule", _2 as "mobile", _3 as "seatsImage", _4 as "wrapper", _5 as "button", _6 as "button_cancel", _7 as "seats__header", _8 as "price", _9 as "seats__table", _a as "meal__price", _b as "wrapper_mobileFullScreen", _c as "seats__header_mobileFullScreen" }
export default { "__esModule": _1, "mobile": _2, "seatsImage": _3, "wrapper": _4, "button": _5, "button_cancel": _6, "seats__header": _7, "price": _8, "seats__table": _9, "meal__price": _a, "wrapper_mobileFullScreen": _b, "seats__header_mobileFullScreen": _c }
